module.exports = __webpack_public_path__ + "img/I-12.cd331b60.svg";